<template>
  <div
    class="wf-article-listing"
    v-if="showArticleListing"
  >
    <div class="container-fluid">
      <div class="wf-article-listing-wrapper">
        <div class="wf-article-listing-heading">
          <div class="wf-article-listing-title">
            <h2
              :class="`h3 m-0 ${settings.center ? 'text-center' : ''}`"
            >
              {{ settings.title }}
            </h2>
          </div>

          <div class="wf-article-listing-controls"
               v-if="settings.showControls"
          >
            <div class="wf-article-listing-controls-item">
              <label
                class="input-label"
                :for="`article-type-${settings.id}`"
              >
                Content type:
              </label>
              <select
                class="custom-select"
                name="article-type"
                :id="`article-type-${settings.id}`"
                v-model="query.type"
                @change="newQuery"
              >
                <option value="">
                  All
                </option>
                <option
                  v-for="typeOption in settings.typeOptions"
                  :value="typeOption.value"
                  :key="typeOption.value"
                >
                  {{ typeOption.name }}
                </option>
              </select>
            </div>
            <div class="wf-article-listing-controls-item">
              <label
                class="input-label"
                :for="`article-category-${settings.id}`"
              >
                Category:
              </label>
              <select
                class="custom-select"
                name="article-category"
                :id="`article-category-${settings.id}`"
                v-model="query.category"
                @change="newQuery"
              >
                <option value="">
                  All
                </option>
                <option
                  v-for="categoryOption in settings.categoryOptions"
                  :value="categoryOption.value"
                  :key="categoryOption.value"
                >
                  {{ categoryOption.name }}
                </option>
              </select>
            </div>
            <div class="wf-article-listing-controls-item">
              <label
                class="input-label"
                :for="`article-sort-${settings.id}`"
              >
                Sort:
              </label>
              <select
                class="custom-select"
                name="article-sort"
                :id="`article-sort-${settings.id}`"
                v-model="query.sort"
                @change="newQuery"
              >
                <option
                  v-for="sortOption in settings.sortOptions"
                  :value="sortOption.value"
                  :key="sortOption.value"
                >
                  {{ sortOption.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div
          class="wf-article-listing-grid"
        >
          <div class="wf-article-listing-item"
               v-for="article in articleListingItems"
               :key="article.id"
          >
            <div class="wf-article-listing-item-inner">
              <div class="wf-article-listing-item-image">
                <a :href="article.url">
                  <img
                    :src="article.teaserImage"
                    :alt="article.teaserImageAltText"
                  >
                </a>
              </div>
              <div class="wf-article-listing-item-tags">
                <span
                  class="badge badge-white text-primary m-1"
                  v-if="article.primaryTag"
                >
                  {{ article.primaryTag }}
                </span>
                <span
                  class="badge badge-white text-primary m-1"
                  v-if="article.secondaryTag"
                >
                  {{ article.secondaryTag }}
                </span>
              </div>
              <div class="wf-article-listing-item-body">
                <div class="secondary-heading">
                  {{ article.category }}
                </div>
                <h3 class="h4">
                  {{ article.title }}
                </h3>
                <div class="wf-article-listing-item-date description">
                  {{ article.date }}
                </div>
                <div
                  class="mb-2"
                  v-html="article.summary"
                />
              </div>
              <div class="wf-article-listing-item-footer">
                <wf-video-modal-button
                  css-class="call-to-action-button btn btn-white border-dark"
                  video-type="element"
                  :video-data="article.media1"
                  v-if="article.type === 'Videos'"
                >
                  Watch now
                  <span class="png-icon png-icon-icons-glyph--k-play-fill" />
                </wf-video-modal-button>
                <a
                  class="call-to-action-button btn btn-white border-dark"
                  :href="article.url"
                >
                  View article
                  <span class="png-icon png-icon-icons-glyph--k-arrow-next" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="wf-article-listing-status"
             v-if="status === 'ready' && articleListingItems.length === 0"
        >
          No articles found.
        </div>
        <!-- <div
          class="wf-article-listing-status"
          v-if="status === 'loading'"
        >
          <div class="spinner-border" role="status" />
          <span>Loading...</span>
        </div> -->
        <div
          class="wf-article-listing-status"
          v-if="status === 'error'"
        >
          <span class="text-danger">
            An error occurred when retrieving news articles. Please try again.
          </span>
        </div>
        <pc-load-more v-if="hasMoreResults" :load-more="nextPage" />
      </div>
    </div>
  </div>
</template>

<script>
import PatcraftApi from '../../scripts/patcraft-api';
import WFVideoModalButton from './wf-video-modal-button.vue';
import PcLoadMore from "./common/pc-loading-more.vue";


export default {
  props: {
    settings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      query: this.settings.query,
      newSettings: this.settings,
      articleListingItems: [],
      hasMoreResults: false,
      status: 'loading'
    }
  },
  methods: {
    // Gets the article items based on the current query settings.
    // Article items are appended to the existing items.
    getArticles: function() {  
      this.verifyURLParams();
      // Get articles list
      let self = this;
      self.status = 'loading',
      PatcraftApi.getArticleListingItems(this.query)
        .then(function (response) {
          self.articleListingItems = [...self.articleListingItems, ...response.data.items];
          self.hasMoreResults = response.data.hasMoreResults;
          self.status = 'ready'
        })
        .catch(function (error) {
          self.status = 'error'
        });
    },
    // Resets current article items and runs a new query based on the current query settings.
    newQuery: function() {
      this.articleListingItems = [];
      this.hasMoreResults = false;
      this.pageNumber = 0;
      this.updatePageURL();
      this.getArticles();
    },
    // Gets the next page of article items for the current query.
    nextPage: function() {
      this.query.pageNumber++;
      this.getArticles();
    },
    updatePageURL: function(){
      // Update URL with the query data
      const url = new URL(window.location);
      url.search = "";
      if(this.query.type != ""){
        url.searchParams.set("type", this.query.type);
      }
      if(this.query.category != ""){
        url.searchParams.set("category", this.query.category);
      }
      url.searchParams.set("sort", this.query.sort);
      window.history.replaceState({}, "", url);
    },
    verifyURLParams: function(){
      if(this.newSettings?.categoryOptions){
        var match = 0;
        this.newSettings.categoryOptions.forEach((item) => {
          if(item.value.toLowerCase() == this.query.category.toLowerCase()){
            this.query.category = item.value;
            match = 1;
          }
        })
        if(match == 0) { 
          this.query.category = ""; 
        }
      }
      if(this.newSettings?.typeOptions){
        var match = 0;
        this.newSettings.typeOptions.forEach((item) => {
          if(item.value.toLowerCase() == this.query.type.toLowerCase()){
            this.query.type = item.value;
            match = 1;
          }
        })
        if(match == 0) { 
          this.query.type = ""; 
        }
      }
      if(this.newSettings?.sortOptions){
        var match = 0;
        this.newSettings.sortOptions.forEach((item) => {
          if(item.value.toLowerCase() == this.query.sort.toLowerCase()){
            this.query.sort = item.value;
            match = 1;
          }
        })
        if(match == 0) { 
          this.query.sort = "date desc"; 
        }
      }
      this.updatePageURL();
    }
  },
  computed: {
    showArticleListing: function() {
      return this.newSettings.showControls || !(this.status === 'ready' && this.articleListingItems.length === 0)
    }
  },
  created: function() {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    this.query = { ...this.query, type: params.get('type') ?? "", category: params.get('category') ?? "", sort: params.get('sort') ?? "date desc" };
    this.verifyURLParams();

    this.newQuery();
  },
  components: {
    'wf-video-modal-button': WFVideoModalButton,
    PcLoadMore
  }
}
</script>